<template>
  <v-text :id="id" ref="textRef" :config="config" v-on="$listeners" />
</template>

<script>
import { filterProps } from '../../../utils/ObjectUtils';
import {
  GlassesGetter,
  mapGetters as mapGlassesGetters,
  prefixType as prefixGlassesType,
} from '../../../store/modules/configurator/glasses';
import { loadFont } from '../../../utils/FontLoader';

export default {
  name: 'ConfiguratorLayerEditorStageZoneText',
  props: {
    id: { type: String, default: undefined },
    draggable: Boolean,
    x: { type: Number, default: 0 },
    y: { type: Number, default: 0 },
    fontFamily: { type: String, default: undefined },
    fontSize: { type: Number, default: undefined },
    scaleX: { type: Number, default: 1 },
    scaleY: { type: Number, default: 1 },
    rotation: { type: Number, default: 0 },
    fill: { type: String, default: undefined },
    opacity: { type: Number, default: 1 },
    underlined: Boolean,
    italic: Boolean,
    text: { type: String, default: undefined },
  },
  data() {
    return {
      fontPromise: undefined,
      isFontLoaded: false,
    };
  },
  computed: {
    ...mapGlassesGetters({
      typo: GlassesGetter.GET_SIZES,
    }),
    typo() {
      return (
        (this.typoId &&
          this.$store.getters[prefixGlassesType(GlassesGetter.FIND_TYPO_BY_ID)](
            this.typoId
          )) ||
        null
      );
    },
    config() {
      const config = {
        ...filterProps(this, [
          'x',
          'y',
          'scaleX',
          'scaleY',
          'rotation',
          'fill',
          'opacity',
          'fontFamily',
          'text',
          'draggable',
        ]),
      };

      if (this.underlined) {
        config.textDecoration = 'underline';
      }

      if (this.italic) {
        config.fontStyle = 'italic';
      }

      return config;
    },
  },
  watch: {
    fontFamily: {
      handler(fontFamily) {
        if (this.isFontLoaded) {
          this.isFontLoaded = false;
        }

        if (fontFamily) {
          this.fontPromise = loadFont(fontFamily).catch(e => {
            console.error(`Unable to load font '${fontFamily}'`);
            console.error(e);
          });
        } else {
          this.fontPromise = Promise.resolve();
        }

        this.fontPromise.then(() => {
          this.isFontLoaded = true;
        });
      },
      immediate: true,
    },
  },
  methods: {
    /**
     * @return {Promise<void>}
     */
    ready() {
      return this.fontPromise;
    },
    /**
     *
     * @return {Text}
     */
    getNode() {
      return this.$refs.textRef.getNode();
    },
  },
};
</script>
